import React, { useMemo, useState, useEffect } from "react";
import axios from "axios";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

import Divider from "@mui/material/Divider";
import Collapse from "@mui/material/Collapse";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import config from "../../../../config";
import { useRegionView } from "../../../../services/useRegionView";
import { useMaterialUIController } from "context";

// Your custom PieChart (react-chartjs-2 wrapper)
import PieChart from "examples/Charts/PieChart";

/**
 * Statistics Page
 * - Header + date range picker (single MDDatePicker)
 * - 4 square blocks (responsive)
 * - Mobile friendly
 */
const GeneralStatistics = () => {
const [controller] = useMaterialUIController();
const { darkMode } = controller;

const currentYear = new Date().getFullYear();

const yearOptions = useMemo(() => {
  const years = [];
  for (let y = 2018; y <= currentYear; y += 1) years.push(y);
  return years;
}, [currentYear]);

// optional selection
const [selectedYear, setSelectedYear] = useState(currentYear);

  const [showDiagrams, setShowDiagrams] = useState(false);
  const [loadingStats, setLoadingStats] = useState(false);
  const [islandId, setIslandId] = useState(null);
    const API_TOKEN = config.MAP_MATCHING_API_TOKEN;
    const API_URL = config.MAP_MATCHING_API_URL;
      const {island_id } = useRegionView();



useEffect(() => {
  // First load: no query params
  fetchBasicStatistics({ withFilters: false });

}, []);

const buildFromToParams = (yearOrNull) => {
  const currentYear = new Date().getUTCFullYear();
  const y = yearOrNull ?? currentYear;

  // from: 01/01/(y - 1) 00:00:00 UTC
  const from = new Date(Date.UTC(y - 1, 0, 1, 0, 0, 0)).toISOString();

  // to: 31/12/(y) 23:59:00 UTC
  const to = new Date(Date.UTC(y, 11, 31, 23, 59, 0)).toISOString();

  return { from, to };
};

  // Dummy data for now (replace later with real API results)
const [stats, setStats] = useState([
  {
    title: "Αριθμός Ατυχημάτων",
    line1: "",
    line2: "",
    line3: "",
  },
  {
    title: "Αριθμός Θανατηφόρων Ατυχημάτων",
    line1: "",
    line2: "",
    line3: "",
  },
  {
    title: "Αριθμός Νεκρών",
    line1: "",
    line2: "",
    line3: "",
  },
  {
    title: "Αριθμός Συνολικών Παθόντων",
    line1: "",
    line2: "",
    line3: "",
  },
]);

const [pieItems, setPieItems] = useState([
  {
    title: "Κατανομή Ατυχημάτων ανά Νησί",
    chart: {
      labels: ["Ρόδος", "Κως", "Σύρος", "Λοιπά"],
      datasets: {
        label: "Ατυχήματα",
        data: [40, 26, 18, 44],
        backgroundColors: ["info", "success", "warning", "error"],
      },
    },
  },
  {
    title: "Κατανομή ανά Κατηγορία Ατυχήματος",
    chart: {
      labels: ["Εκτροπή", "Πλάγια", "Μετωπική", "Λοιπά"],
      datasets: {
        label: "Κατηγορίες",
        data: [34, 28, 12, 54],
        backgroundColors: ["warning", "info", "success", "error"],
      },
    },
  },
  {
    title: "Κατανομή ανά Καιρό",
    chart: {
      labels: ["Καθαρός", "Βροχή", "Ομίχλη", "Λοιπά"],
      datasets: {
        label: "Καιρός",
        data: [84, 26, 6, 12],
        backgroundColors: ["success", "info", "warning", "error"],
      },
    },
  },
  {
    title: "Κατανομή ανά Κατάσταση Δρόμου",
    chart: {
      labels: ["Στεγνό", "Υγρό", "Λάδια", "Λοιπά"],
      datasets: {
        label: "Δρόμος",
        data: [88, 22, 8, 10],
        backgroundColors: ["success", "info", "warning", "error"],
      },
    },
  },
  {
    title: "Κατανομή ανά Αίτια",
    chart: {
      labels: ["Ταχύτητα", "STOP", "Αναστροφή", "Λοιπά"],
      datasets: {
        label: "Αίτια",
        data: [46, 22, 18, 42],
        backgroundColors: ["error", "warning", "info", "success"],
      },
    },
  },
  {
    title: "Κατανομή Παθόντων",
    chart: {
      labels: ["Ελαφρά", "Βαριά", "Νεκροί"],
      datasets: {
        label: "Παθόντες",
        data: [28, 8, 2],
        backgroundColors: ["info", "warning", "error"],
      },
    },
  },
  {
    title: "Κατανομή ανά Σοβαρότητα",
    chart: {
      labels: ["Χαμηλή", "Μέτρια", "Υψηλή"],
      datasets: {
        label: "Σοβαρότητα",
        data: [70, 40, 18],
        backgroundColors: ["success", "warning", "error"],
      },
    },
  },
]);

const handleFetchStatistics = async () => {

  setLoadingStats(true);

  try {
            const { from, to } = buildFromToParams(selectedYear);
    const payload = {
  
      fromDate: from,
      toDate: to,
    };

    console.log("Fetching statistics with payload:", payload);

  await fetchBasicStatistics({ withFilters: true });

    /**
     * 🔜 When API is ready, you will do things like:
     *
     * setStats(response.data.kpis);
     * setPieItems(response.data.pies);
     */

  } catch (error) {
    console.error("Failed to fetch statistics", error);

    // Optional: snackbar / error handling
    // openErrorSB();
  } finally {
    setLoadingStats(false);
  }
};
const prettyRange = useMemo(() => {
  const cy = new Date().getFullYear();
  const y = selectedYear ?? cy;
  return `01/01/${y - 1} - 31/12/${y}`;
}, [selectedYear]);
const fetchBasicStatistics = async ({ withFilters } = { withFilters: false }) => {
  setLoadingStats(true);

  try {
    const params = {};

    if (withFilters) {
      const { from, to } = buildFromToParams(selectedYear);
      params.from = from;
      params.to = to;

      // Island param (later)
      if (island_id != 100) {
        params.island_id = island_id;
      }
    }

const response = await axios.get(
  `${API_URL}/statistics/basic`,
  {
    params,
    headers: {
      "X-API-Key": API_TOKEN,
      "Content-Type": "application/json",
    },
  }
);

    const data = response.data;

    // If backend returns KPIs like: data.kpis = [{title,line1,line2,line3},...]
    if (Array.isArray(data?.stats)) {
      setStats(data.stats);
    }

    // If backend returns pies like: data.pies = [{title, chart:{labels,datasets}}, ...]
    if (Array.isArray(data?.pieItems)) {
      setPieItems(data.pieItems);
    }

    // If your API returns a different shape, paste 1 sample response and I’ll map it precisely.
    console.log("basic statistics:", data);
  } catch (error) {
    console.error("Failed to fetch basic statistics", error);
  } finally {
    setLoadingStats(false);
  }
};

const StatSquare = ({ title, line1, line2, line3 }) => (
  <Card
    sx={{
      height: { xs: 170, sm: 180, md: 170 }, // shorter than square
      borderRadius: 2,
      border: "1px solid rgba(0,0,0,0.12)",
      overflow: "hidden",
    }}
  >
    <MDBox
      sx={{
        height: "100%",
        p: 2.5,
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* TITLE (keep as-is) */}
      <MDTypography variant="button" fontWeight="bold" sx={{ mb: 1 }}>
        {title}
      </MDTypography>

      {/* DETAILS (occupy most space) */}
      <MDBox
        sx={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          gap: 1.2,
        }}
      >
        <MDTypography variant="body2" color="text">
          {line1}
        </MDTypography>

        <MDTypography variant="body2" color="text">
          {line2}
        </MDTypography>

        <MDTypography variant="body2" fontWeight="medium" color="success">
          {line3}
        </MDTypography>
      </MDBox>
    </MDBox>
  </Card>
);
const DetailsSquare = ({ title}) => (
  <Card
    sx={{
      height: { xs: 120, sm: 120, md: 120 }, // 👈 SAME LOGIC as StatSquare
      borderRadius: 2,
      border: "1px solid rgba(0,0,0,0.12)",
      overflow: "hidden"

    }}
  >
    <MDBox
      sx={{
        height: "100%",
        p: 2.5,
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* TITLE (same styling as StatSquare) */}
<MDTypography
  variant="button"
  fontWeight="bold"
  sx={{
    mb: 1,
    whiteSpace: "normal",
    textOverflow: "wrap",
  }}
  title={title}   // 👈 shows full text on hover
>
  {title}
</MDTypography>

    </MDBox>
  </Card>
);

  return (
    <DashboardLayout>
      <MDBox mt={4} p={0}>
        <Grid container spacing={3}>
          {/* Header + Date Range */}
          <Grid item xs={12}>
            <Card sx={{ overflow: "visible" }}>
              <MDBox p={3}>
                <MDTypography variant="h5"   sx={{
                lineHeight: 1.3,
                maxWidth: "900px",
                }}>
                Βασικοί Αριθμοί Εκροής
                </MDTypography>
                <MDTypography variant="button" color="text" sx={{ opacity: 0.8 }}>
                  {prettyRange}
                </MDTypography>

                <Divider sx={{ my: 2 }} />

                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} md={6} >
<MDTypography
  component="label"
  variant="button"
  fontWeight="regular"
  color="text"
  sx={{ mb: 1, mr: 1 }}
>
  Επιλέξτε χρονιά (προαιρετικό)
</MDTypography>

<FormControl size="small" sx={{ minWidth: 150, "& .MuiInputBase-root": { height: "2.5rem" } }}>
  <Select
    value={selectedYear ?? ""}
    onChange={(e) => {
      const v = e.target.value;
      setSelectedYear(v === "" ? null : Number(v));
    }}
    displayEmpty
    size="medium">

    {yearOptions.map((y) => (
      <MenuItem key={y} value={y}>
        {y}
      </MenuItem>
    ))}
  </Select>
</FormControl>
                  </Grid>
                    <Grid
                    item
                    xs={12}
                    md={6}
                    sx={{
                        display: "flex",
                        justifyContent: { xs: "flex-start", md: "flex-end" }, // 👈 right on desktop
                        alignItems: "flex-end",
                    }}
                    >
                    <MDButton
                        variant="gradient"
                        color="info"
                        onClick={handleFetchStatistics}
                        disabled={loadingStats}
                        sx={{
                        "&.MuiButton-root": {
                            textTransform: "none",
                        },
                        }}
                    >
                        {loadingStats ? "Φόρτωση..." : "Ενημέρωση Στατιστικών"}
                    </MDButton>
                    </Grid>
                  <Grid item xs={12} md={12}>
                    <MDBox
                      sx={{
                        borderRadius: 2,
                        p: 2,
                        backgroundColor: "rgba(0,0,0,0.02)",
                      }}
                    >
                      <MDTypography variant="button" color="text" sx={{ opacity: 0.85 }}>
                        Tip: Επίλεξε χρονιά και πάτησε «Ενημέρωση Στατιστικών».
                      </MDTypography>
                    </MDBox>
                  </Grid>
                </Grid>
              </MDBox>
            </Card>
          </Grid>

          {/* 4 Square Stats */}
          {stats.map((s, idx) => (
            <Grid key={idx} item xs={12} sm={6} md={3}>
                <StatSquare
                title={s.title}
                line1={s.line1}
                line2={s.line2}
                line3={s.line3}
                />
            </Grid>
          ))}
        </Grid>
      </MDBox>
      <Grid item xs={12} sx={{ mt: 4 }}>
  <Card sx={{ overflow: "visible" }}>
    <MDBox p={3}>
      <MDBox
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        flexWrap="wrap"
        gap={2}
      >
        <MDTypography variant="h6">Διαγράμματα</MDTypography>

        <FormControlLabel
          control={
            <Switch
              checked={showDiagrams}
              onChange={(e) => setShowDiagrams(e.target.checked)}
            />
          }
          label={showDiagrams ? "Απόκρυψη" : "Εμφάνιση"}
        />
      </MDBox>

      <Collapse in={showDiagrams}>
        <MDBox mt={3}>
          <Grid container spacing={3}>
            {pieItems.map((item, idx) => (
              <Grid key={idx} item xs={12} sm={6} md={4}>
                <Card
                  sx={{
                    borderRadius: 2,
                    border: darkMode
                      ? "1px solid rgba(255,255,255,0.12)"
                      : "1px solid rgba(0,0,0,0.12)",
                    height: "100%",
                    backgroundColor: darkMode ? "#1A2035" : "#ffffff",
                  }}
                >
                  <MDBox p={2.5}>
                    {/* Square details block above each diagram */}
                    <MDBox mb={2}>
                      <DetailsSquare
                        title={item.title}
                        line1={item.line1}
                        line2={item.line2}
                        line3={item.line3}
                      />
                    </MDBox>

                    {/* Pie diagram */}
                    <PieChart
                      title=""
                      description=""
                      height="16rem"
                      chart={item.chart}
                    />
                  </MDBox>
                </Card>
              </Grid>
            ))}
          </Grid>
        </MDBox>
      </Collapse>
    </MDBox>
  </Card>
</Grid>
    </DashboardLayout>
  );
};

export default GeneralStatistics;
